export const FLOW_STATES = Object.freeze({
  CREATE: 'create',
  EDIT: 'edit',
  VIEW: 'view',
});
